import { cache, cacheName } from '@/utils/cacheManager'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { COMPANY_USER_LIST_ROLE_TYPES } from '@/class/cargo/model/parameters/CargoOfRoleType'

export async function getCompanyUserRoleTypes() {
  await cache.load(cacheName.CONFIG)
  const isHc = String(cache.config.get('ToExoSystem')) === 'HC'
  if (isHc) {
    return CargoOfRoleType.COMPANY_USER_ROLE_TYPES_HC
  } else {
    return CargoOfRoleType.COMPANY_USER_ROLE_TYPES
  }
}

export async function getCompanyUserListRoleTypes() {
  await cache.load(cacheName.CONFIG)
  const isHc = String(cache.config.get('ToExoSystem')) === 'HC'
  if (isHc) {
    return CargoOfRoleType.COMPANY_USER_ROLE_TYPES_HC
  } else {
    return CargoOfRoleType.COMPANY_USER_LIST_ROLE_TYPES
  }
}

export async function getRoleTypes() {
  await cache.load(cacheName.CONFIG)
  const isHc = String(cache.config.get('ToExoSystem')) === 'HC'
  if (isHc) {
    return CargoOfRoleType.ROLE_TYPES_HC
  } else {
    return CargoOfRoleType.ROLE_TYPES
  }
}
